<article id="newsSection"
         *ngIf="showNews" 
         class="w-full ci-main-padding py-6 md:py-8">
  <h3 class="ci-txt--cherry mb-3 text-2xl md:text-3xl font-semibold">
    Últimas noticias
  </h3>

  <p class="ci-txt--black-lighten mb-3 text-lg md:text-xl">
    Mantente informado sobre los eventos, proyectos, y decisiones importantes que impactan a nuestra ciudad.
  </p>

  <section class="pt-2">
    <swiper-container *ngIf="lastNewsList" scrollbar-hide="true" slides-per-view="auto" free-mode="true"
      space-between="30" autoplay-delay="2500">
      <swiper-slide *ngFor="let newItem of lastNewsList" class="w-fit p-2 fadein animation-duration-1000 mt-3">
        <section class="w-20rem ci-project-card ci-bg--white shadow-2 flex flex-column border-round-xl overflow-hidden cursor-pointer"
          (click)="selectItem(newItem)">
          <section *ngIf="newItem.archivo" class="w-full h-10rem overflow-hidden">
            <section class="ci-project-card__image w-full h-full bg-cover overflow-hidden relative"
                     [style.background]="getBackgroundLink(newItem.archivo)">
              <section class="ci-project-card__overlay-bg w-full h-full absolute top-0 right-0 left-0 bottom-0">
              </section>
            </section>
          </section>

          <section class="w-full flex gap-2 flex-column justify-content-center p-2">
            <h3 class="ci-ellipsis-2 text-sm font-semibold ci-txt--black">
              {{newItem.titulo}}
            </h3>

            <section class="flex">
              <small class="ci-txt--black-lighten">
                {{getDate(newItem.fecha)}}
              </small>
            </section>
          </section>
        </section>
      </swiper-slide>
    </swiper-container>

    <swiper-container *ngIf="!lastNewsList" scrollbar-hide="true" slides-per-view="auto" space-between="30"
      autoplay-delay="2500">
      <swiper-slide *ngFor="let newItem of [1,1,1,1,1,1]" class="w-fit p-2 fadein animation-duration-1000">
        <section class="w-20rem h-12rem shadow-2 border-round-xl overflow-hidden bg-black-alpha-10">
        </section>
      </swiper-slide>
    </swiper-container>
  </section>

  <section *ngIf="scrollSectionId" class="w-full flex justify-content-center pt-5 fadeindown animation-duration-500 z-3"
           (click)="scrollToFeatureSection()">
    <i class="bi bi-chevron-double-down ci-txt--cherry text-3xl md:text-4xl ci-project-banner__arrow-down cursor-pointer">
    </i>
  </section>
</article>

<p-dialog [header]="'.'" [modal]="true" [(visible)]="showDetail" [position]="'bottom'" [closable]="false"
  [dismissableMask]="true" [style]="{ width: '45vw' }" [breakpoints]="{ '1199px': '80vw', '575px': '100vw' }">
  <article *ngIf="selectedItem" class="w-11 mx-auto relative">
    <section class="w-fit md:mx-auto relative border-round overflow-hidden">
      <img [src]="getLink(selectedItem.archivo)" alt="News photo"
        class="w-full md:w-auto h-full md:max-h-20rem border-round">

      <section class="absolute bottom-0 right-0 shadow-1">
        <section
          class="w-fit flex ci-txt--grey ci-bg--white p-2 border-round-lg border-noround-bottom border-noround-right">
          <small class="md:text-sm">
            <i class="bi bi-calendar-event mx-2"></i> {{getDate(selectedItem.fecha)}}
          </small>
        </section>
      </section>
    </section>

    <section class="w-full">
      <section class="w-full flex align-items-center justify-content-between ci-txt--grey">
        <section class="my-3 text-sm md:text-lg">
          {{selectedItem.category.nombre}}
        </section>

        <section class="text-sm md:text-lg">
          <i class="bi bi-eye"></i> {{selectedItem.visitas}}
        </section>
      </section>

      <h3 class="w-full ci-txt--black mb-3 text-lg md:text-xl">
        {{selectedItem.titulo}}
      </h3>

      <div class="ci-txt--black-lighten text-lg mb-2 text-justify" [innerHTML]="selectedItem.contenido">
      </div>

      <section *ngIf="verifyMP4Extension(selectedItem.video) && selectedItem.video !== ''" class="w-full h-full relative my-4">
        <video #videoElement controls class="w-full h-full overflow-hidden border-round" style="object-fit: cover;">
          <source [src]="getLink(selectedItem.video)" type="video/mp4">
          Tu navegador no soporta el tag de video.
        </video>
      </section>
    </section>

    <section class="w-fit fixed top-0 right-0">
      <section class="w-1rem h-1rem border-round-3xl flex align-items-center justify-content-center"
        (click)="closeNewDetail()">
        <i class="bi bi-x-circle-fill text-3xl ci-txt--cherry cursor-pointer"></i>
      </section>
    </section>
  </article>

  <ng-template pTemplate="footer">
    <div class="w-11 mx-auto my-3">
      <button class="w-full ci-btn ci-btn--small ci-btn__purple" (click)="closeNewDetail()">
        Cerrar
      </button>
    </div>
  </ng-template>
</p-dialog>